import ClientMetricsCard from '@/components/client/dashboard/ClientMetricsCard'
import { ClientAssignedPlansCard } from '@/components/client/dashboard/ClientAssignedPlansCard'
import ClientOverviewCard from '@/components/client/dashboard/ClientOverviewCard'
import ClientActivityLogCard from '@/components/client/dashboard/ClientActivityLogCard'
import { ClientCommerceCard } from '@/components/client/dashboard/ClientCommerceCard'
import { ClientOverviewLoadingState } from '@/components/client/ClientTabLoadingStates'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/_dashboard/clients/$clientId/_layout/',
)({
  component: ClientOverview,
  pendingComponent: ClientOverviewLoadingState,
})

function ClientOverview() {
  const { clientId } = Route.useParams()

  return (
    <div className="w-full md:w-[90%] mx-auto mb-10">
      <div className="client-overview-primary-grid grid grid-cols-1 lg:grid-cols-12 gap-4 max-w-full items-stretch auto-rows-[1fr]">
        <div className="client-overview-card-span w-full lg:col-span-4">
          <ClientOverviewCard clientId={clientId} />
        </div>
        <div className="client-overview-card-span w-full lg:col-span-4">
          <ClientMetricsCard clientId={clientId} />
        </div>
        <div className="client-overview-card-span w-full lg:col-span-4">
          <ClientAssignedPlansCard clientId={clientId} />
        </div>
      </div>
      <div className="client-overview-secondary-grid mt-5 grid grid-cols-1 gap-4 lg:grid-cols-2">
        <ClientActivityLogCard clientId={clientId} />
        <ClientCommerceCard clientId={clientId} />
      </div>
    </div>
  )
}
